var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _vm.templatesLoaded
        ? _c(
            "b-row",
            [
              _vm.noTemplates
                ? _c(
                    "b-col",
                    { attrs: { lg: "12" } },
                    [
                      _c("b-card", [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center" },
                          [_vm._v(_vm._s(_vm.$t("TEMPLATE.NOTHING")))]
                        )
                      ])
                    ],
                    1
                  )
                : _c("b-col", { attrs: { lg: "12" } }, [
                    _c("div", { staticClass: "pull-right views" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("TEMPLATE_VIEW.VIEW")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link",
                          attrs: { type: "button", disabled: !_vm.gridView }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-th-list fa-lg mt-3",
                            on: {
                              click: function($event) {
                                _vm.toggleViews("table")
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link",
                          attrs: { type: "button", disabled: _vm.gridView }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-th-large fa-lg mt-3",
                            on: {
                              click: function($event) {
                                _vm.toggleViews("grid")
                              }
                            }
                          })
                        ]
                      )
                    ])
                  ]),
              _vm._v(" "),
              _vm._l(_vm.templateList, function(template) {
                return _vm.gridView
                  ? _c(
                      "b-col",
                      {
                        key: template.id,
                        staticClass: "template-container",
                        attrs: { lg: "2" }
                      },
                      [
                        _c(
                          "zoom-center-transition",
                          [
                            _c("b-card", { attrs: { "show-footer": "" } }, [
                              _c("img", {
                                staticClass: "card-img",
                                attrs: {
                                  src: _vm._f("withBaseUrl")(
                                    template.webp_thumbnail_url ||
                                      template.thumbnail_url
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "footer-text",
                                  attrs: { slot: "footer" },
                                  slot: "footer"
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm._f("truncate")(
                                          template.title.toUpperCase(),
                                          12,
                                          "..."
                                        )
                                      )
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "total-pages" }, [
                                    _vm._v(
                                      _vm._s(
                                        template.total_pages +
                                          _vm.$t("TEMPLATE_VIEW.PAGES")
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "card-overlay" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "Train",
                                          params: {
                                            id: template.first_template_id
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            size: "sm",
                                            variant: "outline-light"
                                          }
                                        },
                                        [_vm._v("MAP TEMPLATE")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !template.is_public
                                    ? _c(
                                        "div",
                                        { staticClass: "btn btn-public" },
                                        [
                                          _c("i", {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            staticClass: "fa fa-user",
                                            attrs: {
                                              title: _vm.$t(
                                                "TEMPLATE.ENABLE_FORM"
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.openSubmitFormStatusModal(
                                                  template,
                                                  true
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "btn btn-public" },
                                        [
                                          _c("i", {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            staticClass: "fa fa-user-times",
                                            attrs: {
                                              title: _vm.$t(
                                                "TEMPLATE.DISABLE_FORM"
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.disableForm(template.id)
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _vm.isAdminRole
                                    ? _c(
                                        "div",
                                        { staticClass: "btn btn-link" },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-trash",
                                            on: {
                                              click: function($event) {
                                                _vm.confirmModal(template)
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              !_vm.gridView && !_vm.noTemplates
                ? _c(
                    "b-col",
                    { attrs: { lg: "12" } },
                    [
                      _c("SearchBar", {
                        attrs: { title: _vm.$t("ROUTE_NAME.Template Listing") },
                        on: { filterInput: _vm.setFilter }
                      }),
                      _vm._v(" "),
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "sm",
                          items: _vm.templateList,
                          fields: _vm.tableFields,
                          filter: _vm.filter,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc
                        },
                        on: {
                          "update:sortBy": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function($event) {
                            _vm.sortDesc = $event
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "HEAD_id",
                            fn: function(data) {
                              return [
                                _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                              ]
                            }
                          },
                          {
                            key: "HEAD_title",
                            fn: function(data) {
                              return [
                                _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                              ]
                            }
                          },
                          {
                            key: "HEAD_total_pages",
                            fn: function(data) {
                              return [
                                _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                              ]
                            }
                          },
                          {
                            key: "HEAD_brand",
                            fn: function(data) {
                              return [
                                _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                              ]
                            }
                          },
                          {
                            key: "HEAD_updated_at",
                            fn: function(data) {
                              return [
                                _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                              ]
                            }
                          },
                          {
                            key: "HEAD_actions",
                            fn: function(data) {
                              return [
                                _c("em", [_vm._v(_vm._s(_vm.$t(data.label)))])
                              ]
                            }
                          },
                          {
                            key: "actions",
                            fn: function(data) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "btn-group" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "Train",
                                            params: {
                                              id: data.item.first_template_id
                                            }
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            staticClass: "first-button",
                                            attrs: { variant: "primary" }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("TEMPLATE.TRAIN")
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !data.item.is_public
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            staticClass: "btn-public",
                                            attrs: {
                                              title: _vm.$t(
                                                "TEMPLATE.ENABLE_FORM"
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.openSubmitFormStatusModal(
                                                  data.item,
                                                  true
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-user"
                                            })
                                          ]
                                        )
                                      : _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            staticClass: "btn-public",
                                            attrs: {
                                              title: _vm.$t(
                                                "TEMPLATE.DISABLE_FORM"
                                              )
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.disableForm(data.item.id)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-user-times"
                                            })
                                          ]
                                        ),
                                    _vm._v(" "),
                                    _vm.isAdminRole
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            attrs: {
                                              variant: "primary",
                                              title: _vm.$t("COMMON.DELETE")
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.confirmModal(data.item)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-trash"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true }
                                          }
                                        ],
                                        staticClass: "last-button",
                                        attrs: { title: "Export to Rems" },
                                        on: {
                                          click: function($event) {
                                            _vm.templateApi(data.item.id)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          ref: "export-rems-" + data.item.id,
                                          staticClass: "icon-cloud-upload"
                                        }),
                                        _vm._v(" "),
                                        _c("i", {
                                          ref: "spinner-rems-" + data.item.id,
                                          staticClass:
                                            "fa fa-spin fa-spinner hide"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _c(
            "b-row",
            _vm._l(_vm.templateLoadingContents, function(loadingContent) {
              return _c(
                "b-col",
                {
                  key: loadingContent,
                  staticClass: "c-placeholder",
                  attrs: { lg: "2" }
                },
                [
                  _c(
                    "b-card",
                    [
                      _c(
                        "content-placeholders",
                        [
                          _c("content-placeholders-img", {
                            staticStyle: { height: "180px" }
                          }),
                          _vm._v(" "),
                          _c("content-placeholders-text", {
                            attrs: { lines: 2 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            })
          ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "tempModal",
          attrs: {
            "hide-header-close": "",
            centered: "",
            title: _vm.$t("COMMON.DELETE_CONFIRM"),
            "ok-title": _vm.$t("COMMON.DELETE"),
            "cancel-title": _vm.$t("COMMON.CANCEL"),
            "ok-variant": "secondary",
            "cancel-variant": "light"
          },
          on: { ok: _vm.deleteTemplate }
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("TEMPLATE.DELETE_CONTENT", {
                  TEMPLATE_TITLE: _vm.seletedTemplateTitle
                })
              ) +
              "\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "submitFormStatus",
          attrs: {
            centered: "",
            "hide-header-close": "",
            title: "Form Submission Configuration"
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("p", { staticClass: "required" }, [
                      _vm._v(
                        "Note: Add any one of field to make it as a document title "
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "b-form-group",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { sm: "4" } }, [
                        _c("label", [_vm._v("Page No")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "required" }, [_vm._v("*")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("b-form-select", {
                            attrs: { options: _vm.pages },
                            model: {
                              value: _vm.selectedPageNo,
                              callback: function($$v) {
                                _vm.selectedPageNo = $$v
                              },
                              expression: "selectedPageNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.selectedPageNo
                ? _c(
                    "b-form-group",
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { sm: "4" } }, [
                            _c("label", [_vm._v("Field")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "required" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-select", {
                                attrs: { options: _vm.fields },
                                model: {
                                  value: _vm.selectedField,
                                  callback: function($$v) {
                                    _vm.selectedField = $$v
                                  },
                                  expression: "selectedField"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "modal-footer" }, slot: "modal-footer" },
            [
              _c(
                "b-btn",
                {
                  attrs: {
                    id: "addNewField",
                    size: "sm",
                    variant: "secondary"
                  },
                  on: {
                    click: function($event) {
                      _vm.enableForm()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("COMMON.SAVE")) + " ")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: { size: "sm", variant: "light" },
                  on: {
                    click: function($event) {
                      _vm.$refs.submitFormStatus.hide()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("COMMON.CLOSE")) + " ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25f84f24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25f84f24","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/List.vue
// module id = 1083
// module chunks = 2